import React from 'react';
import YouTube from '@material-ui/icons/YouTube';

export default function YouTubeIcon(props) {
    const { ...other } = props;

    return (
        <YouTube {...other} />
    );
}